<template>
  <button
    type="button"
    class="alternador"
    :aria-label="`Buscando em ${rotuloAtual.toLowerCase()}. Clique para buscar ${rotuloAlternativo.toLowerCase()}`"
    :title="`Trocar para ${rotuloAlternativo.toLowerCase()}`"
    @click="emit('atualizar', alternativo.valor)"
  >
    <span class="alternador__rotulo">{{ rotuloAtual }}</span>
    <svg class="alternador__icone" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M4 9h13M14 6l3 3-3 3" />
      <path d="M20 15H7l3 3M7 15l3-3" />
    </svg>
  </button>
</template>

<script setup>
  import { computed } from 'vue';

  /* Os valores sao os aceitos pelo parametro `res` do endpoint de busca. */
  const RECURSOS = [
    { valor: 'shops', rotulo: 'Lojas' },
    { valor: 'products', rotulo: 'Produtos' }
  ];

  const props = defineProps({
    recurso: {
      type: String,
      default: 'shops'
    }
  });

  const emit = defineEmits(['atualizar']);

  const atual = computed(() => RECURSOS.find((opcao) => opcao.valor === props.recurso) || RECURSOS[0]);
  const alternativo = computed(() => RECURSOS.find((opcao) => opcao.valor !== atual.value.valor));

  const rotuloAtual = computed(() => atual.value.rotulo);
  const rotuloAlternativo = computed(() => alternativo.value.rotulo);
</script>

<style scoped>
  /*
   * Tom claro da marca, como o seletor de cidade: e um filtro da busca, e nao
   * pode competir com o botao do Portal ADM, que e a acao principal do topo.
   */
  .alternador {
    display: inline-flex;
    flex: none;
    align-items: center;
    gap: var(--espaco-2);
    padding: var(--espaco-2) var(--espaco-3);
    border-radius: var(--raio-pilula);
    background: var(--cor-marca-clara);
    color: var(--cor-marca-escura);
    font-size: 0.78rem;
    font-weight: 700;
    white-space: nowrap;
    transition: background var(--transicao-padrao), color var(--transicao-padrao);
  }

  .alternador:hover {
    background: var(--cor-marca);
    color: #fff;
  }

  .alternador__icone {
    opacity: 0.75;
    transition: transform var(--transicao-padrao);
  }

  .alternador:hover .alternador__icone {
    transform: rotate(180deg);
  }
</style>
